module.exports = __webpack_public_path__ + "static/img/MLDJ.7f953bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MLDJ.png
// module id = hgos
// module chunks = 34